import xfetch from '@ms/fetch'

/**
 * Fetches the message count based on the commentary type.
 *
 * @param {number} commentaryType - The type of commentary.
 *                                  1: General message,
 *                                  2: Post message,
 *                                  3: All messages.
 * @returns {Promise} - A promise that resolves to the message count.
 */
export const fetchMessageCount = (commentaryType = 1) => {
  return xfetch(`/msg/site/info/count?commentaryType=${commentaryType}`)
}
